import { render, staticRenderFns } from "./GameData.vue?vue&type=template&id=ac00f01e&"
import script from "./GameData.vue?vue&type=script&lang=js&"
export * from "./GameData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports